import { useMutation, useQuery } from '@tanstack/react-query';
import { DisclaimersApi } from 'services/ApiService';
import { ValidateUserDisclaimerRequest } from 'services/ApiService/Legal/LegalApiClient';
import { logError } from 'services/Logger';

const DISCLAIMER_QUERIES_KEY = 'disclaimerQueries';

export const disclaimerKeys = {
    getUserDisclaimer: (application?: string) => [DISCLAIMER_QUERIES_KEY, 'getUserDisclaimer', application],
    getLastValidatedContent: () => [DISCLAIMER_QUERIES_KEY, 'getLastValidatedContent'],
    generateContent: (language?: string, application?: string) => [DISCLAIMER_QUERIES_KEY, 'generateContent', language, application],
};

export const useGetUserDisclaimer = (application?: string) => {
    return useQuery({
        queryKey: disclaimerKeys.getUserDisclaimer(application),
        queryFn: async () => {
            try {
                return await DisclaimersApi.getUserDisclaimer(application);
            } catch (error) {
                logError(error);
                throw error;
            }
        },
        staleTime: Infinity,
        gcTime: Infinity,
    });
};

export const useGetLastValidatedContent = () => {
    return useQuery({
        queryKey: disclaimerKeys.getLastValidatedContent(),
        queryFn: async () => {
            try {
                return await DisclaimersApi.getLastValidatedContent();
            } catch (error) {
                logError(error);
                throw error;
            }
        },
        staleTime: Infinity,
        gcTime: Infinity,
    });
};

export const useGenerateDisclaimerContent = (language?: string, application?: string) => {
    return useQuery({
        queryKey: disclaimerKeys.generateContent(language, application),
        queryFn: async () => {
            try {
                return await DisclaimersApi.generateContent({
                    language: language!,
                    application: application!,
                });
            } catch (error) {
                logError(error);
                throw error;
            }
        },
        enabled: !!language && !!application,
        staleTime: Infinity,
        gcTime: Infinity,
    });
};

export const useValidateUserDisclaimer = (options?: { onSuccess?: () => void }) => {
    return useMutation({
        mutationFn: async (request: ValidateUserDisclaimerRequest) => {
            return await DisclaimersApi.validateUserDisclaimer(request);
        },
        onSuccess: () => {
            options?.onSuccess?.();
        },
        onError: (error: any) => {
            logError(error);
            throw error;
        },
    });
};

